<template>
  Do something pretty
  <div v-for="option in options" :key="option.value">
    <input
      type="radio"
      :name="name"
      :value="option.value"
      @change="updateState($event)"
      :checked="state.answers[stateKey] === option.value"
    /><label>{{ option.text }}</label>
  </div>
</template>
<script>
import { state } from '@/lib/state'
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    stateKey: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      state: state,
    }
  },
  methods: {
    updateState: function (event) {
      state.answers[this.stateKey] = event.target.value
      state.displayAnswers[this.stateKey] = event.target.text
      this.emitter.emit(`validate-${this.stateKey}`)
    },
  },
}
</script>
